/* global Booqable, CookieConsent */
const CookieNotice = {
  // PUBLIC

  init (config, translations = { en: {} }) {
    CookieConsent.run(this._settings(config, translations))
  },

  showPreferencesModal () {
    CookieConsent.showPreferences()
  },

  servicesTable () {
    const services = []

    Booqable._apps.marketing.forEach(function (app) {
      if (services.find((service) => service.name === app.name)) {
        return
      }

      services.push({
        name: app.name,
        domain: app.domain,
        desc: app.description
      })
    })

    return services
  },

  // PRIVATE

  _services () {
    // These will be listed in the cookie consent modal
    // and the user can then choose to accept or deny
    // cookies on a per-app basis.
    return Booqable._apps.marketing.map(function (app) {
      if (!app.name) {
        return null
      }

      return { name: app.name, label: app.name }
    }).filter(function (app) { return app })
      .reduce(function (acc, app) { return { ...acc, [app.name]: app } }, {})
  },

  _refreshAppConsent (cookie) {
    // Every time the user changes his cookie preferences
    // we need to refresh the apps to reflect the new state.
    Booqable._apps.marketing.forEach(function (app) {
      if (cookie.services.tracking.includes(app.name)) {
        app.onConsent()
      } else {
        app.onDeny()
      }
    })
  },

  _settings (config, translations = { en: {} }) {
    const self = this
    const defaults = {
      hideFromBots: !navigator.webdriver,
      autoShow: false,
      categories: {
        necessary: {
          enabled: true,
          readOnly: true
        },
        tracking: {
          services: this._services()
        }
      },
      language: {
        default: 'en',
        translations
      },
      onConsent: function ({ cookie }) { self._refreshAppConsent(cookie) },
      onChange: function ({ cookie }) { self._refreshAppConsent(cookie) }
    }

    return Object.assign({}, defaults, config)
  }
}

if (window.CookieNotice === undefined) {
  window.CookieNotice = CookieNotice
}
